module.exports = __webpack_public_path__ + "static/home-plane-window-998438e95c41aa8cefdab8101d63296a.jpg";